import { caption } from '@atlaskit/adf-schema';
import { captionKeymap } from './pm-plugins/keymap';
import { default as createCaptionPlugin } from './pm-plugins/main';
var captionPlugin = function captionPlugin(_ref) {
  var api = _ref.api;
  return {
    name: 'caption',
    nodes: function nodes() {
      return [{
        name: 'caption',
        node: caption
      }];
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'caption',
        plugin: function plugin(_ref2) {
          var portalProviderAPI = _ref2.portalProviderAPI,
            providerFactory = _ref2.providerFactory,
            eventDispatcher = _ref2.eventDispatcher,
            dispatch = _ref2.dispatch;
          return createCaptionPlugin(portalProviderAPI, eventDispatcher, providerFactory, dispatch, api);
        }
      }, {
        name: 'captionKeymap',
        plugin: captionKeymap
      }];
    }
  };
};
export default captionPlugin;